import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("button", {
        class: "buttonBase w-100 mb-2",
        onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            (...args) => (_ctx.locationSearch && _ctx.locationSearch(...args)))
    }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "icon-location" }, null, -1),
            _createTextVNode(" Mein Standort ", -1)
        ]))]));
}
